var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { StudyTranslationLanguage } from "healthex-common/study-translation-language.dtos";
import { willNeverHappen } from "healthex-common/utils";
import { computed } from "mobx";
import { getObservableT } from "../Infra/i18next";
const t = getObservableT("common");
export var HXLanguageChangerMenuInfoType;
(function (HXLanguageChangerMenuInfoType) {
    HXLanguageChangerMenuInfoType["FULL_TEXT"] = "FULL_TEXT";
    HXLanguageChangerMenuInfoType["CODE"] = "CODE";
})(HXLanguageChangerMenuInfoType || (HXLanguageChangerMenuInfoType = {}));
export class HXLanguageChangerButtonModel {
    constructor(container, useInMemoryLanguage = false, type = HXLanguageChangerMenuInfoType.CODE) {
        this.browserLanguageUIManager = container.browserLanguageUIManager;
        this.useInMemoryLanguage = useInMemoryLanguage;
        this.type = type;
    }
    get currentLanguage() {
        return this.browserLanguageUIManager.currentLanguage;
    }
    get selectedLanguageCode() {
        switch (this.currentLanguage) {
            case StudyTranslationLanguage.en:
                return "EN";
            case StudyTranslationLanguage.es:
                return "ES";
        }
        return willNeverHappen(this.currentLanguage);
    }
    get selectedLanguage() {
        switch (this.currentLanguage) {
            case StudyTranslationLanguage.en:
                return t("English");
            case StudyTranslationLanguage.es:
                return t("Spanish");
        }
        return willNeverHappen(this.currentLanguage);
    }
    get menuInfo() {
        const languages = Object.keys(StudyTranslationLanguage).sort();
        const languageInfo = [];
        languages.forEach((language) => {
            switch (language) {
                case StudyTranslationLanguage.en:
                    languageInfo.push({
                        text: this.type === HXLanguageChangerMenuInfoType.FULL_TEXT ? "English" : "EN (English)",
                        selected: this.currentLanguage === StudyTranslationLanguage.en,
                        action: () => this.useInMemoryLanguage
                            ? this.browserLanguageUIManager.setInMemoryLanguage(StudyTranslationLanguage.en)
                            : this.browserLanguageUIManager.setPersistentLanguage(StudyTranslationLanguage.en),
                    });
                    break;
                case StudyTranslationLanguage.es:
                    languageInfo.push({
                        text: this.type === HXLanguageChangerMenuInfoType.FULL_TEXT ? "Español" : "ES (Español)",
                        selected: this.currentLanguage === StudyTranslationLanguage.es,
                        action: () => this.useInMemoryLanguage
                            ? this.browserLanguageUIManager.setInMemoryLanguage(StudyTranslationLanguage.es)
                            : this.browserLanguageUIManager.setPersistentLanguage(StudyTranslationLanguage.es),
                    });
                    break;
            }
        });
        return languageInfo;
    }
}
__decorate([
    computed
], HXLanguageChangerButtonModel.prototype, "currentLanguage", null);
__decorate([
    computed
], HXLanguageChangerButtonModel.prototype, "selectedLanguageCode", null);
__decorate([
    computed
], HXLanguageChangerButtonModel.prototype, "selectedLanguage", null);
